import React from "react"
import { twElementStyles } from "../../twElementStyles"
import { FieldErrorsImpl, DeepRequired, FieldValues } from 'react-hook-form'
interface TextareaFieldProps extends React.TextareaHTMLAttributes<HTMLInputElement> {
    label: string,
    register: any,
    errors?: FieldErrorsImpl<DeepRequired<FieldValues>>
}
export const TextareaField: React.FC<TextareaFieldProps> = ({ label, register, errors, ...props }) => {
    let fieldName = register.name;
    let random = `Texfel` + Math.round(Math.random() * 10000)

    return (
        <div className="h-fit">
            <div className="relative h-fit rounded-t-lg bg-gray-100 dark:bg-slate-700 pt-5">

                <textarea id={random} className={`pt-0 resize-none block rounded-t-lg mt-1 px-2.5 w-full text-sm border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 peer placeholder:text-transparent focus:placeholder:text-gray-500 dark:focus:placeholder:text-gray-600 text-gray-900 bg-inherit ${errors?.[fieldName] ? 'border-red-500 dark:text-white dark:border-red-500' : 'border-gray-300 dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:border-blue-600 dark:hover:border-blue-500 hover:border-blue-600'}`}{...register} {...props} placeholder={props.placeholder ?? ' '}></textarea>
                {
                    label && <label htmlFor={random} className={`absolute rounded-t-lg font-semibold duration-300 transform -translate-y-4 text-[.7rem] top-4 z-10 origin-[0] py-0.5 pl-2.5 peer-placeholder-shown:text-sm peer-placeholder-shown:translate-y-0 peer-focus:text-[.7rem] w-full peer-focus:-translate-y-4 ${errors?.[fieldName] ? 'peer-focus:text-red-600 dark:peer-focus:text-red-400 peer-focus:dark:text-blue-500 text-red-500 dark:text-red-400' : 'peer-focus:text-blue-600 dark:peer-focus:text-blue-300 peer-focus:dark:text-blue-500 text-gray-500 dark:text-gray-400'}`}>{label} {register.required} {register.required ? <span className="text-red-700">*</span> : ''}</label>
                }
            </div>
            {errors?.[fieldName]?.message && (
                <p id="outlined_error_help" className="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">
                    {errors?.[fieldName]?.message?.toString()}
                </p>
            )}

        </div>
    )
}